// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.solutions.revdirect.RevDirectRegisterLocationRequest */
/* istanbul ignore next */
@GandalfModel
export class RevDirectRegisterLocationRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Location Direct Address is required' } })
	@GandalfValidator({ sizeString: { message: 'Location Direct Address must be between 4 and 100 characters', minLength: 4, maxLength: 100 } })
	@GandalfProperty({ designType: String, isRequired: true })
	directUsername!: string;

	@GandalfValidator({ notNull: { message: 'Location is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	practiceLocationId!: number;

}
